var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("tracking.tracks_bulk_details"),
        "show-extract": _vm.hasLinesData,
        "extract-disabled": _vm.activateSpinner,
        "extract-text": _vm.$t("common.extract_lines"),
      },
      on: { extract: _vm.exportLinesCSV },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.Tracking
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.file_information"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              {
                                staticClass: "form-group justify-content-start",
                              },
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("tracking.silo"),
                                        inputValue: _vm.Tracking.Silo || "-",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.reception_date"
                                        ),
                                        inputValue: _vm.Tracking.Date
                                          ? _vm.getDateDay(_vm.Tracking.Date)
                                          : "-",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel:
                                          _vm.$t("tracking.file_type"),
                                        inputValue: _vm.getFileType(
                                          _vm.Tracking.FileType
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.entity_emitter"
                                        ),
                                        inputValue:
                                          _vm.Tracking.bic_from || "-",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.bic_billable"
                                        ),
                                        inputValue:
                                          _vm.Tracking.bic_facturable || "-",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel:
                                          _vm.$t("tracking.file_name"),
                                        inputValue:
                                          _vm.Tracking.FileName || "-",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.nb_requests"
                                        ),
                                        inputValue: String(
                                          _vm.Tracking.NbRequests || 0
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.nb_requests_ok"
                                        ),
                                        inputValue: String(
                                          _vm.Tracking.NbRequestsOK || 0
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.nb_requests_error"
                                        ),
                                        inputValue: String(
                                          _vm.Tracking.NbRequestsKO || 0
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.final_status"
                                        ),
                                        inputValue: _vm.translateStatus(
                                          _vm.Tracking.FinalStatus
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "tracking.processing_state"
                                        ),
                                        inputValue: _vm.translateStatusFile(
                                          _vm.Tracking.StatusFile
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-4", attrs: { sm: "4" } },
                                  [
                                    _c("label", { attrs: { id: "" } }, [
                                      _vm._v(_vm._s(_vm.$t("tracking.file"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-start align-item-start",
                                      },
                                      [
                                        _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeJson(
                                                  _vm.Tracking.idTrackingBulk,
                                                  "trackingBulk",
                                                  "see"
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeJson(
                                                  _vm.Tracking.idTrackingBulk,
                                                  "trackingBulk",
                                                  "download"
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.lines"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.TracksList.length > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { overflow: "auto" } },
                                  [
                                    _c("b-table", {
                                      staticClass: "table table-striped mb-0",
                                      attrs: {
                                        hover: "",
                                        fields: _vm.fieldsTrack,
                                        items: _vm.TracksList,
                                        selectable: _vm.TracksList.length > 0,
                                        "empty-text": _vm.$t(
                                          "common.security.no_result"
                                        ),
                                        role: "table",
                                        "sticky-header": "",
                                      },
                                      on: {
                                        "row-clicked": _vm.handleRowClicked,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(idMsg)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.value
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(CreationDateRq1)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        _vm.getDateDay(
                                                          data.value
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(CreationDateRp2)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        _vm.getDateDay(
                                                          data.value
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(BICFrom)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.value
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(BICTo)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.value
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(IBAN)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.value
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(Name)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.item.Name
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(Siren)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.item.Siren
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(Siret)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.item.Siret
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(TVAIntracom)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.item.TVAIntracom
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(TestedData)",
                                            fn: function (data) {
                                              return [
                                                data.item.Name
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item.Name
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : data.item.Siren
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item.Siren
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : data.item.Siret
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item.Siret
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : data.item.TVAIntracomm
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item
                                                              .TVAIntracomm
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : data.item.LEI
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item.LEI
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : data.item.EUID
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayValue(
                                                            data.item.EUID
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("-")]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(Result)",
                                            fn: function (data) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayValue(
                                                        data.item
                                                          .Business_status
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(TechStatusCode)",
                                            fn: function (data) {
                                              return [
                                                data.item.TechStatusCode !== ""
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.displayValue(
                                                              _vm.translateTechStatusCode(
                                                                data.item
                                                                  .TechStatusCode
                                                              )
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.displayValue(
                                                              _vm.$t(
                                                                "common.monitoring.success"
                                                              )
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(ReasonCodeAll)",
                                            fn: function (data) {
                                              return [
                                                data.item.ReasonCodeEntity
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.displayValue(
                                                              _vm.$t(
                                                                "tracking.flagCACP.reason_code_optional_entity_list." +
                                                                  data.item
                                                                    .ReasonCodeEntity
                                                              )
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ])
                                                  : _c("span", [_vm._v("-")]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3012118869
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.history"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.Tracking.History && _vm.Tracking.History.length
                              ? _c(
                                  "table",
                                  { staticClass: "table table-striped" },
                                  [
                                    _c(
                                      "tbody",
                                      [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("tracking.status")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.status_code"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.processing_date"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.Tracking.History,
                                          function (history) {
                                            return _c(
                                              "tr",
                                              { key: history.id },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    history.Status !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "tracking.status-" +
                                                                  history.Status
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    history.StatusCode !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.translateTechStatusCode(
                                                                history.StatusCode
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.getDate(
                                                            history.Date
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }